import { MapProvider } from "../../types/enums";
import { IGeoServiceApiKeys } from "../geo-service-api-keys";
import { GoogleProvider } from "./google/google-provider";
import { HereProvider } from "./here/here-provider";
import { IMapProvider } from "./map-provider.interface";
import { NoneProvider } from "./none/none-provider";

export class MapProviderFactory {
    static getMapProvider(mapProviderId: MapProvider, apiKey?: string): IMapProvider {
        switch (mapProviderId) {
            case MapProvider.GOOGLE:
                if (!apiKey)
                    return new NoneProvider();
                return new GoogleProvider({ apiKey: apiKey });

            case MapProvider.HERE:
                if (!apiKey)
                    return new NoneProvider();
                return new HereProvider({ apiKey: apiKey });

            default:
                return new NoneProvider();
        }
    }

    // getMapProvider only checks that a key is present, not that it belongs to the provider,
    // so callers must pick both together or a mismatched key silently yields a blank map.
    static getApiKey(mapProviderId: MapProvider, apiKeys: IGeoServiceApiKeys): string {
        switch (mapProviderId) {
            case MapProvider.GOOGLE:
                return apiKeys.google;

            case MapProvider.HERE:
                return apiKeys.here;

            default:
                return "";
        }
    }
}